import {AfterViewInit, Component} from '@angular/core';

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint.component.html',
    styleUrls: ['./imprint.component.scss'],
    standalone: false
})
export class ImprintComponent implements AfterViewInit {

  constructor() {
  }

  ngAfterViewInit(): void {
    document.getElementById('email').innerHTML = '' +
      '<a href="&#x6d;&#x61;&#x69;&#x6c;&#x74;&#x6f;&#x3a;&#x69;&#x6e;&#x66;&#x6f;&#x40;&#x6f;&#x73;&#x64;&#x2e;&#x61;&#x74;">' +
      '&#x69;&#x6e;&#x66;&#x6f;&#x40;&#x6f;&#x73;&#x64;&#x2e;&#x61;&#x74;' +
      '</a>';
    document.getElementById('tel').innerHTML = '' +
      '<a ' +
      'href="&#x74;&#x65;&#x6c;&#x3a;&#x2b;&#x34;&#x33;&#x2d;&#x31;&#x2d;&#x33;&#x31;&#x39;&#x2d;&#x33;&#x33;&#x39;&#x35;">' +
      '&#x2b;&#x34;&#x33;&#x2d;&#x31;&#x2d;&#x33;&#x31;&#x39;&#x2d;&#x33;&#x33;&#x39;&#x35;' +
      '</a>';
  }

}
